export default {
  name: 'accountingFlexField',
  props: ['currentItem'],
  data() {
    return {
      loader: false,
      flexFieldModal: false,
      flexFieldType: null,
      flexValue: null,
      flexDescription: null,
      flexData: [],
      flexFields: [
        {
          key: 'flex_value',
          label: 'Flex Value',
          class: ''
        },
        {
          key: 'description',
          label: 'Description',
          class: ''
        }
      ],
      currentPage: 1,
      totalRows: null,
      perPage: 10,
      codeCombination: null,
      codeCombinationValue: {
        entity: {
          code: null,
          value: null
        },
        account: {
          code: null,

          value: null
        },
        unit: {
          code: null,
          value: null
        },
        department: {
          code: null,
          value: null
        },
        interEntity: {
          code: null,
          value: null
        },
        spare1: {
          code: null,
          value: null
        },
        spare2: {
          code: null,
          value: null
        }
      }
    };
  },
  watch: {
    currentPage: function() {
      this.getFlexData();
    },
    perPage: function() {
      this.currentPage = 1;
      this.getFlexData();
    }
  },
  mounted() {
    if (this.currentItem && this.currentItem.code_combination_value) {
      setTimeout(() => {
        this.loader = true;
        this.codeCombinationValue = this.currentItem.code_combination_value;
        this.loader = false;
      }, 200);
    }
  },
  methods: {
    openValueSet(type) {
      if (type === 'entity') {
        this.flexFieldType = 'ENTITY';
      } else if (type === 'account') {
        this.flexFieldType = 'ACCOUNT';
      } else if (type === 'unit') {
        this.flexFieldType = 'UNIT';
      } else if (type === 'department') {
        this.flexFieldType = 'DEPARTMENT';
      } else if (type === 'interEntity') {
        this.flexFieldType = 'INTER_ENTITY';
      } else if (type === 'spare1') {
        this.flexFieldType = 'SPARE1';
      } else if (type === 'spare2') {
        this.flexFieldType = 'SPARE2';
      }
      this.showHideFlexFieldModal(true);
    },
    showHideFlexFieldModal(flag) {
      this.flexFieldModal = flag;
      this.getFlexData();
    },
    getFlexData() {
      const payload = {
        _page: this.currentPage - 1,
        _limit: this.perPage,
        flex_value_type: this.flexFieldType,
        flex_value: this.flexValue,
        description: this.flexDescription
      };
      this.loader = true;
      this.$store
        .dispatch('intWorkflow/getFlexFields', payload)
        .then(response => {
          this.loader = false;
          if (response.status === 200) {
            let result = response.data.data.page;
            this.flexData = [];
            this.flexData = result;
            this.totalRows = response.data.data.total_elements;
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    clearFlexData() {
      this.flexValue = null;
      this.flexDescription = null;
      this.flexData = [];
    },
    rowSelected(item) {
      if (this.flexFieldType === 'ENTITY') {
        this.codeCombinationValue.entity = {
          code: item.flex_value,
          value: item.description
        };
      } else if (this.flexFieldType === 'ACCOUNT') {
        this.codeCombinationValue.account = {
          code: item.flex_value,
          value: item.description
        };
      } else if (this.flexFieldType === 'UNIT') {
        this.codeCombinationValue.unit = {
          code: item.flex_value,
          value: item.description
        };
      } else if (this.flexFieldType === 'DEPARTMENT') {
        this.codeCombinationValue.department = {
          code: item.flex_value,
          value: item.description
        };
      } else if (this.flexFieldType === 'INTER_ENTITY') {
        this.codeCombinationValue.interEntity = {
          code: item.flex_value,
          value: item.description
        };
      } else if (this.flexFieldType === 'SPARE1') {
        this.codeCombinationValue.spare1 = {
          code: item.flex_value,
          value: item.description
        };
      } else if (this.flexFieldType === 'SPARE2') {
        this.codeCombinationValue.spare2 = {
          code: item.flex_value,
          value: item.description
        };
      }
      this.showHideFlexFieldModal(false);
    },
    // saveCodeCombination() {
    //   const fields = [
    //     { path: 'entity.code', label: 'Entity' },
    //     { path: 'account.code', label: 'Account' },
    //     { path: 'unit.code', label: 'Unit' },
    //     { path: 'department.code', label: 'Department' },
    //     { path: 'interEntity.code', label: 'Inter-Entity' },
    //     { path: 'spare1.code', label: 'Spare1' },
    //     { path: 'spare2.code', label: 'Spare2' }
    //   ];
    //   const getValue = (obj, path) =>
    //     path.split('.').reduce((o, key) => (o ? o[key] : null), obj);
    //   const missingFields = fields
    //     .filter(field => !getValue(this.codeCombinationValue, field.path))
    //     .map(field => field.label);
    //   if (missingFields.length) {
    //     alert(`Please select: ${missingFields.join(', ')}`);
    //     return;
    //   }
    //   const c = this.codeCombinationValue;
    //   const codeCombination = `${c.entity.code}.${c.account.code}.${c.unit.code}.${c.department.code}.${c.interEntity.code}.${c.spare1.code}.${c.spare2.code}`;
    //   this.codeCombination = codeCombination;
    //   this.$emit('update-code-combination', this.codeCombination);
    //   this.$emit('update-code-combination-value', this.codeCombinationValue);
    // },
    saveCodeCombination() {

      const fields = [
        { path: 'entity.code', label: 'Entity' },
        { path: 'account.code', label: 'Account' },
        { path: 'unit.code', label: 'Unit' },
        { path: 'department.code', label: 'Department' },
        { path: 'interEntity.code', label: 'Inter-Entity' },
        { path: 'spare1.code', label: 'Spare1' },
        { path: 'spare2.code', label: 'Spare2' }
      ];

      const getValue = (obj, path) =>
        path.split('.').reduce((o, key) => (o ? o[key] : null), obj);

      const missingFields = fields
        .filter(field => !getValue(this.codeCombinationValue, field.path))
        .map(field => field.label);

      if (missingFields.length) {
        alert(`Please select: ${missingFields.join(', ')}`);
        return;
      }
      const confirmSave = confirm(
        'Are you sure you want to save this code combination?'
      );

      if (!confirmSave) return;

      const c = this.codeCombinationValue;

      const codeCombination = `${c.entity.code}.${c.account.code}.${c.unit.code}.${c.department.code}.${c.interEntity.code}.${c.spare1.code}.${c.spare2.code}`;

      this.codeCombination = codeCombination;

      this.$emit('update-code-combination', this.codeCombination);
      this.$emit('update-code-combination-value', this.codeCombinationValue);
    }
  }
};